import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, flatMap } from 'rxjs/operators';

import { KeycloakService } from '../../../authentication/keycloak.service';
import { ShellApplication } from '../../../core';

const MIN_SEC_TOKEN_TTL = 30;

@Injectable({
    providedIn: 'root'
})
export class HttpRequestInterceptor implements HttpInterceptor {

    constructor(
        private keycloakService: KeycloakService,
        private shellApplication: ShellApplication
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const client = this.getAuthClient();
        let token = this.getToken(client);

        const headers = request.headers.set('Content-Type', 'application/json; charset=utf-8');
        let authRequest = request.clone({ headers });

        window.dispatchEvent(new CustomEvent('customResetLastRequestEvent'));

        if (!token) {
            return next.handle(authRequest).pipe(
                catchError((error) => this.handleError(error))
            );
        }

        authRequest = authRequest.clone({
            headers: authRequest.headers.set('Authorization', `Bearer ${token}`)
        });

        if (client.isTokenExpired(MIN_SEC_TOKEN_TTL)) {
            const tokenRefreshSubject = new Subject<HttpRequest<any>>();

            client.updateToken(MIN_SEC_TOKEN_TTL).then(() => {
                token = this.getToken(client);
                authRequest = authRequest.clone({
                    headers: authRequest.headers.set('Authorization', `Bearer ${token}`)
                });
                tokenRefreshSubject.next(authRequest);
                tokenRefreshSubject.complete();
            });

            return tokenRefreshSubject.pipe(
                flatMap((data) => {
                    return next.handle(data);
                }),
                catchError((error) => this.handleError(error))
            );
        }

        return next.handle(authRequest);
    }

    private handleError(error: HttpErrorResponse) {
        const client = this.getAuthClient();
        client.clearToken();
        client.login();
        return throwError(error);
    }

    private getAuthClient(): any {
        return this.keycloakService.getClient() || this.shellApplication.authClient;
    }

    private getToken(client: any) {
        const keycloakClient = client;
        if (keycloakClient && keycloakClient.token) {
            return keycloakClient.token;
        }
        return false;
    }
}
